'use client';
import { create } from 'zustand';

// ---- Types ----

export interface AlertConfig {
  id: string;
  message: string;
  type: 'saving' | 'success' | 'error' | 'info';
  duration?: number;
}

export interface ConfirmDialog {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
}

// ---- Store ----

interface UIStore {
  // ---- Alerts ----
  alerts: AlertConfig[];

  // ---- Confirm dialog ----
  confirmDialog: ConfirmDialog;

  // ---- Actions - Alerts ----
  addAlert: (alert: AlertConfig) => void;
  removeAlert: (id: string) => void;
  setAlerts: (alerts: AlertConfig[] | ((prev: AlertConfig[]) => AlertConfig[])) => void;

  // ---- Actions - Confirm dialog ----
  setConfirmDialog: (dialog: ConfirmDialog | ((prev: ConfirmDialog) => ConfirmDialog)) => void;
}

const defaultConfirmDialog: ConfirmDialog = {
  isOpen: false,
  title: '',
  message: '',
  onConfirm: () => {},
};

export const useUIStore = create<UIStore>((set) => ({
  // ---- Alerts ----
  alerts: [],

  // ---- Confirm dialog ----
  confirmDialog: defaultConfirmDialog,

  // ---- Actions - Alerts ----
  addAlert: (alert) =>
    set((state) => ({
      alerts: [...state.alerts, alert],
    })),
  removeAlert: (id) =>
    set((state) => ({
      alerts: state.alerts.filter((a) => a.id !== id),
    })),
  setAlerts: (alerts) =>
    set((state) => ({
      alerts: typeof alerts === 'function' ? alerts(state.alerts) : alerts,
    })),

  // ---- Actions - Confirm dialog ----
  setConfirmDialog: (dialog) =>
    set((state) => ({
      confirmDialog: typeof dialog === 'function' ? dialog(state.confirmDialog) : dialog,
    })),
}));
